import React, { Component } from 'react';
import { message } from 'antd';
import { Redirect } from 'react-router-dom';
import LoginView from '../views/LoginView';
import { app } from '../../base';

class LoginContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: this.props.authenticated,
        };
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this);
    }

    authWithEmailPassword(email, password) {
        app.auth().signInWithEmailAndPassword(email, password)
            .then((user) => {
                if (user) {
                    this.setState({ redirect: true });
                    // this.loginForm.reset();
                }
                return true;
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(`${errorCode} ${errorMessage}`);
                message.error('Error en el usuario o contraseña');
                return false;
            });
    }

    render() {
        const { redirect } = this.state;
        if (this.props.authenticated === true || redirect === true) {
            const to = {
                pathname: '/',
                state: { authenticated: true },
            };
            return <Redirect to={to} />;
        }
        return (
            <LoginView
                loginHandle={this.authWithEmailPassword}
            />
        );
    }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/containers/LoginContainer.jsx